import { useFetchApiData } from "./useFetchApiData";
import { TimelineViewModel } from "../models/preplabModels";

export const useGetTimelines = () => {
    return useFetchApiData<TimelineViewModel>("/api/Timeline/GetTimelines");
};
